import { Code, ConnectError } from "@connectrpc/connect";

export type AdminReloginReason = "portal_token_error" | "backend_unauthenticated";

export type AdminAccessIssue = {
  kind: "relogin";
  reason: AdminReloginReason;
};

const defaultMessageByReason: Record<AdminReloginReason, string> = {
  portal_token_error: "Failed to get portal token",
  backend_unauthenticated: "Backend session is unauthenticated",
};

export class AdminAccessError extends Error {
  constructor(
    public readonly issue: AdminAccessIssue,
    message?: string,
  ) {
    super(message ?? defaultMessageByReason[issue.reason]);
    this.name = "AdminAccessError";
  }
}

// AdminAccessError にはしない: 分類すると redirect にかぶって再ログイン画面が一瞬出る。
export class PortalLoginRedirectError extends Error {
  constructor() {
    super("Portal login redirect in progress");
    this.name = "PortalLoginRedirectError";
  }
}

export function isPortalLoginRedirect(error: unknown): boolean {
  return error instanceof PortalLoginRedirectError;
}

export function getAdminAccessIssue(error: unknown): AdminAccessIssue | null {
  if (error instanceof AdminAccessError) {
    return error.issue;
  }

  if (!(error instanceof ConnectError)) {
    return null;
  }

  if (error.code === Code.Unauthenticated) {
    return {
      kind: "relogin",
      reason: "backend_unauthenticated",
    };
  }

  return null;
}
